<template>
  <AppSection
    id="monitoring-jobs"
    type="section"
    :title="$getConst.pages.connectivity_test.failed_jobs"
  >
    <AppDataTable
      ref="failedTable"
      :fields="fields"
      :end-point="endPoint"
      :selectable="true"
      @getCheckedIds="getCheckedJobIds"
    >

      <template v-slot:payload="item">
        #job-{{ item.row.id }} : {{ item.data.job }} ...
        <b-link @click="showPayloadDetails(item.row)"  v-b-tooltip.hover
                  :title="$t($getConst.pages.button.show_more)"> <i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

      <template v-slot:exception="item">
        {{ item.data.substr(0, 40) }} ...
        <b-link @click="showExceptionDetails(item.row)" v-b-tooltip.hover
                  :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

    </AppDataTable>
    <template>
      <AppConfirmButtons
        :is-loading="isLoading"
        submit-text="Launch"
        no-cancel
        @onSubmit="launchJobs()"
        :isDisabled="checkedJobIds.length === 0"
      />
    </template>
    <ShowPayloadDetailsModal v-if="job" :id="payloadDetailsModal" :job="job" size="xl"/>
    <ShowExceptionDetailsModal v-if="job" :id="exceptionDetailsModal" :job="job" size="xl"/>
  </AppSection>
</template>

<script>
  import {launchJobs} from "../../../../api/scopes.api";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import ShowPayloadDetailsModal from "./ShowPayloadDetailsModal"
  import ShowExceptionDetailsModal from "./ShowExceptionDetailsModal"

  export default {
    name: "jobsFailed",
    components: {AppSpinner, AppSection, AppDataTable, AppConfirmButtons, ShowPayloadDetailsModal, ShowExceptionDetailsModal},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        endPoint: null,
        fields: [
          {key: 'payload', sortable: false, filterable: false},
          {key: 'exception', sortable: false, filterable: false},
          {key: 'failed_at', sortable: false, filterable: false},
        ],
        payloadDetailsModal: 'show-payload-details-modal',
        exceptionDetailsModal: 'show-exception-details-modal',
        job: null,
        checkedJobIds: []
      }
    },
    created() {
      this.endPoint = '/scopes/' + this.scope_id + '/failed_jobs';
    },
    methods: {
      launchJobs() {
        this.isLoading = true;
        launchJobs(this.checkedJobIds).then(
          (response) => {
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            this.$router.push({name: this.$getConst.routesNames.administration.pendingJobs});
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
          })
      },
      getCheckedJobIds(data){
        this.checkedJobIds = data;
      },
      showPayloadDetails(job) {
        this.job = job;
        this.$nextTick(() => this.$bvModal.show(this.payloadDetailsModal));
      },
      showExceptionDetails(job) {
        this.job = job;
        this.$nextTick(() => this.$bvModal.show(this.exceptionDetailsModal));
      },
    }
  }
</script>

<style scoped>

</style>
